export const FORM_CONTROL_YES = "yes";
export const FORM_CONTROL_NO = "no";
